export default "__VITE_ASSET__D84_7hRc__"